export class UIHelperTable2excel {
	public exportAsExcel(headers, data, mapFunction) {
		console.log('exportAsExcel', {headers, data, mapFunction});
		//if (vm['excel.callback'])
		//   vm['excel.callback'](ret, ordered, vm.headers);

		let escape = 'AAAAAAAAA';
		let escapeBis = 'XXXXXXXXX';
		let str = '';
		for (let header of headers) {
			str += escape + header.label + escape + ',';
		}
		str += '\r\n';
		for (let row of data) {
			// is object
			for (let header of headers) {
				let c = mapFunction ? mapFunction(header.id, row[header.id], row) : row[header.id];
				//if (c == null)
				//  c = '';
				str += escape + (c == null ? '' : c) + escape + ',';
			}
			str += '\r\n';
		}

		let strFinal = str.replace(/"/g, escapeBis);
		strFinal = strFinal.replace(/AAAAAAAAA/g, '"');
		strFinal = strFinal.replace(/XXXXXXXXX/g, '""');

		let blob = new Blob([strFinal], {type: 'octet/stream'});

		let url = window.URL.createObjectURL(blob); // a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvString));

		if (navigator['msSaveOrOpenBlob']) {
			navigator['msSaveBlob'](blob, 'Book.csv');
		} else {
			let a = document.createElement('a');
			var universalBOM = '\uFEFF';
			a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + strFinal));

			a.download = 'table.csv';
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
		}
		window.URL.revokeObjectURL(url);
	}
}
